
const getAddressComponentValue = (value) => {
  if (!value?.length) {
    return '';
  }
  return value[0]?.long_name || '';
}

export const normalizeGoogleAddress = (address_components) => {
  const place_street_number = address_components.filter(pc => pc.types.includes('street_number'));
  const place_route = address_components.filter(pc => pc.types.includes('route'));
  const place_premise = address_components.filter(pc => pc.types.includes('premise'));
  const place_suite = address_components.filter(pc => pc.types.includes('subpremise'));
  const place_city = address_components.filter(pc => pc.types.includes('locality'));
  const place_state = address_components.filter(pc => pc.types.includes('administrative_area_level_1'));
  const place_zip = address_components.filter(pc => pc.types.includes('postal_code'));

  const number = getAddressComponentValue(place_street_number);
  const street = getAddressComponentValue(place_route) || getAddressComponentValue(place_premise);
  const suite = getAddressComponentValue(place_suite);

  const city = getAddressComponentValue(place_city);
  const state = getAddressComponentValue(place_state);
  const zip = getAddressComponentValue(place_zip);

  const addressComponents = [];
  const normalizedSuite = suite.includes('#') ? suite : `#${suite}`;
  const line1 = [number, street, (suite ? `${normalizedSuite}` : '')].join(' ').trim();
  if (line1) {
    addressComponents.push(line1);
  }
  addressComponents.push(city);
  addressComponents.push(`${state} ${zip}`);
  return addressComponents.join(', ');
};
